export const parseChatId = (cid: string | undefined): number | null => {
  if (!cid) return null

  // Expected format: "messaging:convo-123" or similar
  const parts = cid.split(':')
  if (parts.length !== 2) return null

  const lastPart = parts[1].split('-')
  if (lastPart.length === 0) return null

  const id = lastPart[lastPart.length - 1]
  return /^\d+$/.test(id) ? Number(id) : null
}
